// src/pages/RarityCardList.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function RarityCardList() {
    const [rarities, setRarities] = useState([]);
    const [licenses, setLicenses] = useState([]);
    const [selectedLicense, setSelectedLicense] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const [resRarities, resLicenses] = await Promise.all([
                api.get("/rarity-cards"),
                api.get("/license-cards"),
            ]);
            setRarities(resRarities.data);
            setLicenses(resLicenses.data);
        } catch (err) {
            console.error(err);
            alert("Erreur lors du chargement des données.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cette rareté ?")) return;

        try {
            await api.delete(`/rarity-cards/${id}`);
            alert("Rareté supprimée avec succès.");
            setRarities((prev) => prev.filter((r) => r.id !== id));
        } catch (err) {
            console.error(err);
            if (err.response?.status === 409) {
                alert("Impossible de supprimer cette rareté car elle est utilisée par des cartes.");
            } else {
                alert("Erreur lors de la suppression de la rareté.");
            }
        }
    };

    const filteredRarities = selectedLicense
        ? rarities.filter((r) => r.license_card_id === parseInt(selectedLicense))
        : rarities;

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Liste des Raretés de Cartes</h1>

            <div className="flex items-center space-x-4 mb-4">
                <button
                    onClick={() => navigate("/add-rarity_card")}
                    className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2"
                >
                    Ajouter une rareté
                </button>
                <select
                    id="license"
                    value={selectedLicense}
                    onChange={(e) => setSelectedLicense(e.target.value)}
                    className="border p-2 rounded dark:bg-gray-700 bg-white"
                >
                    <option value="">-- Toutes les licences --</option>
                    {licenses.map((l) => (
                        <option key={l.id} value={l.id}>
                            {l.license_card}
                        </option>
                    ))}
                </select>
            </div>
            {loading ? (
                <Loading message="Chargement des raretés..." />
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border text-sm text-center">
                        <thead className="bg-gray-100 dark:bg-gray-800">
                            <tr>
                                <th className="border px-2 py-1">Licence</th>
                                <th className="border px-2 py-1">Nom de la rareté</th>
                                <th className="border px-2 py-1">Supprimer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRarities.map((r, index) => {
                                const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                                return (
                                    <tr key={r.id} className={`${bgColor}`}>
                                        <td className="border px-2 py-1">{r.license_card?.license_card || ""}</td>
                                        <td className="border px-2 py-1">{r.rarity_name}</td>
                                        <td className="border px-2 py-1">
                                            <button
                                                onClick={() => handleDelete(r.id)}
                                                className="text-red-500 hover:text-red-700 text-2xl"
                                            >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                            {filteredRarities.length === 0 && (
                                <tr>
                                    <td colSpan="3" className="text-gray-500 py-3">
                                        Aucune rareté trouvée pour cette licence.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
